import { render, staticRenderFns } from "./InfoEduTutors.vue?vue&type=template&id=0dabf914"
import script from "./InfoEduTutors.vue?vue&type=script&lang=js"
export * from "./InfoEduTutors.vue?vue&type=script&lang=js"
import style0 from "./InfoEduTutors.vue?vue&type=style&index=0&id=0dabf914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports